import { BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH } from "common/constants";
import React, { useEffect, useState } from "react";
import Banner from "common/Banner/Banner";
import { AuthUser } from "@shared/types";
import { useRestrictedCountriesPurchase } from "utils/hooks/misc";
import { StylableButton } from "common/Buttons/Button";
import styled, { useTheme } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import IntercomLink from "common/Text/IntercomLink";
import { useHideBillingButtons } from "features/settings/common/hooks.tsx";
import { localStorageService } from "utils/localStorageService";

interface SubscriptionExpiredBannerProps {
  user: AuthUser;
  showCloseButton?: boolean;
}

const SubscriptionExpiredBanner = ({
  user,
  showCloseButton,
}: SubscriptionExpiredBannerProps) => {
  const theme = useTheme();
  const { onPurchaseClick } = useRestrictedCountriesPurchase();
  const hidePurchaseButton = useHideBillingButtons();
  const [hideBanner, setHideBanner] = useState(
    Boolean(localStorageService.getParsedValue<number>(BANNER_KEY))
  );

  useEffect(() => {
    if (showCloseButton) return;
    localStorageService.removeValue(BANNER_KEY);
    setHideBanner(false);
  }, [showCloseButton]);

  const onCloseClick = () => {
    localStorageService.setValue(BANNER_KEY, 1);
    setHideBanner(true);
  };

  if (!user.isExpired() || (showCloseButton && hideBanner)) return null;

  return (
    <Banner
      color={theme.colors.secondaryRed}
      onCloseClick={showCloseButton ? onCloseClick : undefined}
    >
      Your subscription has expired - Renew now{" "}
      {user?.in_view_only_grace_period
        ? "to prevent interruptions in your service"
        : "to continue using Cornix"}
      .
      {!hidePurchaseButton && (
        <RenewButton
          onClick={() =>
            onPurchaseClick(BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH)
          }
          style={{ marginLeft: 12, marginRight: 12 }}
        >
          Renew
        </RenewButton>
      )}
      <StyledLink articleId="5814831">Read More</StyledLink>
    </Banner>
  );
};

export default SubscriptionExpiredBanner;

const BANNER_KEY = "hide_subscription_expired";

const RenewButton = styled(StylableButton).attrs({ $type: "outlined" })`
  color: ${(p) => p.theme.colors.secondaryRed} !important;
  border-color: ${(p) => p.theme.colors.secondaryRed} !important;
  &:hover {
    border-color: ${(p) => p.theme.colors.secondaryRed};
  }
`;
const StyledLink = styled(IntercomLink)`
  color: ${(p) => p.theme.colors.secondaryRed};
  &:hover {
    color: ${(p) => hexToRGB(p.theme.colors.secondaryRed, 0.7)};
  }
`;
